export const getDefault = ({ color = '#818386' } = {}) => {
  const schema = {
    name: 'SubWebLinks',
    isLoading: false,
    hasError: false,
    hasLink: false,
    href: null,
    isLocal: true,
    title: 'Links em destaque',
    activeColor: color,
    data: [
      {
        info: {
          label: 'Nome',
          value: 'Exemplo 1'
        },
        type: 'link',
        extra: '/pt/'
      },
      {
        info: {
          label: 'Nome',
          value: 'Exemplo 2'
        },
        type: 'link',
        extra: '/pt/'
      },
      {
        info: {
          label: 'Nome',
          value: 'Exemplo 3'
        },
        type: 'link',
        extra: '/pt/'
      },
    ],
  };
  return schema;
};
